import AssigneeSelectV2 from "../../../components/AssigneeSelect";
import { BuildingOffice2Icon, MapPinIcon } from "@heroicons/react/24/outline";
import { DueDateDisplayField } from "../../../activities/ActivityIndicator";

interface FooterCardPropsType {
  task: any;
  onChange: (value: any) => void;
}

const FooterCard = (props: FooterCardPropsType) => {
  const { task, onChange } = props;
  const assigneeIds = task.getIn(["data", "assignees", "value"]);
  const nextActivityDatetime = new Date(task.getIn(["data", "nextActivityDatetime", "value"]));

  const type = task.get("type");

  const renderLeft = () => {
    if (type == "SALE") {
      const stage = task.getIn(["data", "stage", "value"]);
      const stateEl =
        stage == "Won" ? (
          <div className="flex items-center rounded-full bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
            Won
          </div>
        ) : (
          <DueDateDisplayField dateTimeString={nextActivityDatetime} />
        );
      return <div className={"flex items-center space-x-1 text-xs"}>{stateEl}</div>;
    }
    if (type == "CONTACT") {
      return (
        <div className={"flex space-x-1 truncate ..."}>
          <BuildingOffice2Icon className={"w-6"} />
          {task.getIn(["data", "account", "value", "label"]) || ""}
        </div>
      );
    }
    if (type == "COMPANY") {
      return (
        <div className={"flex space-x-1 truncate ..."}>
          <MapPinIcon className={"w-6"} />
          {task.getIn(["data", "country", "value", "label"]) || ""}
        </div>
      );
    }
  };

  const renderRight = () => {
    if (type == "SALE") {
      return (
        <div className="flex justify-end">
          <AssigneeSelectV2
            value={assigneeIds}
            showTriggerHeight={true}
            onChange={(ids) => {
              const assignees = Array.isArray(ids) ? ids.join(",") : ids || "";
              onChange({
                fieldId: "assignees",
                fieldValue: assignees,
              });
            }}
            multiple={true}
            placeholder="Assign to..."
            className="w-auto"
          />
        </div>
      );
    }
  };

  return (
    <div className="flex items-center justify-between">
      <div className={"text-nowrap"}>{renderLeft()}</div>
      <div className={"w-full"}>{renderRight()}</div>
    </div>
  );
};

export default FooterCard;
